
export const LANG_OPTIONS: Map<string, string> =
  new Map([
    ["en-au", $localize`English (AU)`],
    ["en-us", $localize`English (US)`],
    ["es-us", $localize`Spanish (US)`],
    ["fr-ca", $localize`French (CA)`]
  ]);

export const LANG_OPTIONS_WITH_OUT_TRANSLATION: Map<string, string> =
  new Map([
    ["en-au", 'English (AU)'],
    ["en-us", 'English (US)'],
    ["es-us", 'Español (US)'],
    ["fr-ca", 'Français (CA)']
  ]);
